export const CHANNEL_ID = 'betting';
export const PROMOTIONS_CHANNEL_ID = 'promotions';
export const DEPOSIT_NORMAL_TYPE = 'DEPOSIT';

export const SCROLL_DELTA = 25;
export const HEADER_HEIGHT = 44;

export const getPromotionsPathname = (locale) => `/betting/${locale}/apps/promotions`;
